import NbBtnDropdownDemo from "../../backyard/view/wheel/NbBtnDropdownDemo.vue";
import ByNbCheckView from "../../backyard/view/wheel/NbCheckDemo.vue";
import ByNbUEditorView from "../../backyard/view/wheel/NbUEditorDemo.vue";
import NbEditorDemo from "../../backyard/view/wheel/NbEditorDemo.vue";
import NbTimePickerView from "../../backyard/view/wheel/NbTimePickerDemo.vue";
import NbTankView from "../../backyard/view/wheel/NbTankDemo.vue";
import NbTagDemo from "../../backyard/view/wheel/NbTagDemo.vue";

let lbWheelRouter = [];

let byWheelRouter = [
	{
		path: 'wheel/nb-btn-dropdown',
		name: "byNbBtnDropdown",
		component: NbBtnDropdownDemo,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byNbBtnDropdown",
					title: "NbBtnDropdownDemo"
				}
			]
		}
	},
	{
		path: 'wheel/nb-check',
		name: "byWheelNbCheck",
		component: ByNbCheckView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byWheelNbCheck",
					title: "NbCheckDemo"
				}
			]
		}
	},
	{
		path: 'wheel/nb-ueditor',
		name: "byWheelNbUEditor",
		component: ByNbUEditorView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byWheelNbUEditor",
					title: "NbUEditorDemo"
				}
			]
		}
	},
	{
		path: 'wheel/nb-editor',
		name: "byWheelNbEditor",
		component: NbEditorDemo,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byWheelNbEditor",
					title: "NbEditorDemo"
				}
			]
		}
	},
	{
		path: 'wheel/nb-time-picker',
		name: "byWheelNbTimePicker",
		component: NbTimePickerView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byWheelNbTimePicker",
					title: "NbTimePickerDemo"
				}
			]
		}
	},
	{
		path: 'wheel/nb-tank',
		name: "byWheelNbTank",
		component: NbTankView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byWheelNbTank",
					title: "NbTankDemo"
				}
			]
		}
	},
	{
		path: 'wheel/nb-tag',
		name: "byWheelNbTag",
		component: NbTagDemo,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byWheelNbTag",
					title: "NbTagDemo"
				}
			]
		}
	}

];


export {lbWheelRouter, byWheelRouter}





// WEBPACK FOOTER //
// ./src/common/router/WheelRouter.js